export const menu = [
    {
        header: "FRITTI",
        content: [
            "Patatine Fritte</br>",
            "Crocchette di Patate</br>",
            "Anelli di Cipolla</br>",
            "Olive all'ascolana</br>",
            "Verdure in pastella</br>",
            "Hub Nuggets</br>",
        ],
        prezzo: [
            "3,50€</br>",
            "3,90€</br>",
            "4,50€</br>",
            "4,50€</br>",
            "4,50€</br>",
            "4pz 3,50€ - 6pz 4,90€ - 10pz 6,40€ </br>",
        ],
    },
    {
        header: "DOLCI",
        content: [
            "Cheeseckae ai frutti di bosco</br>",
            "Torta della Nonna</br>",
            "Souffle al cioccolato</br>",
            "Tiramisù</br>",
            "Caffè</br>",
        ],
        prezzo: [
            "5,00€</br>",
            "5,00€</br>",
            "5,00€</br>",
            "5,00€</br>",
            "1,50€</br>",
        ],
    },
    {
        header: "BEVANDE",
        content: [
            "Acqua</br>",
            "Coca Cola e Coca Zero 33cl</br>",
            "Aranciata Amara S.Pellegrino 33cl</br>",
            "Aranciata S.Pellegrino 33cl</br>",
            "Chinotto S.Pellegrino 33cl</br>",
            "Sprite 33cl</br>",
            "Estathe pesca o limone 33cl</br>",
            "Menabrea - Corona Extra 33cl</br>",
            "Ichnusa non filtrata 50cl</br>",
            "Birra artigianale Chiarodiluna 33cl</br>",
            "Birra artigianale ACME 33cl</br>",
            "Herrnbrau Pils 50cl</br>",
            "Herrnbrau Weisse 50cl</br>",
            "Gin Tonic, Spritz</br>",
            "Amari</br>",
        ],
        prezzo: [
            "1,00€</br>",
            "2,50€</br>",
            "3,00€</br>",
            "3,00€</br>",
            "3,00€</br>",
            "3,00€</br>",
            "3,00€</br>",
            "3,50€</br>",
            "5,00€</br>",
            "5,00€</br>",
            "6,00€</br>",
            "6,00€</br>",
            "6,00€</br>",
            "6,00€</br>",
            "3,00€ </br>",
        ],
    },
    {
        header: "WRHUB",
        content: [
            "<strong>MEAT WRHUB</strong></br>Hamburger di carne Piemontese, salsa Hub Speicla, Grana Padano D.O.P., pomodoro, insalata</br>",
            "<strong>CHICKEN WRHUB</strong></br>Suprema di pollo croccante, insalata gentile, salsa BBQ, Edamer Tedesco</br>",
            "<strong>SERRANO</strong></br>Prosciutto crudo Jamon Serrano, rucola, pomodoro ramato, maionese</br>",
            "<strong>VEGAN WRHUB</strong></br>Cavolo cappuccio saltato, rucola, zucchine alla piastra, pomodoro ramato</br>",
            "<strong>TUNA WRHUB</strong></br>Tonno, cipolla caramellata, maionese, pomodoro ramato, rucola</br>",
        ],
        prezzo: [
            "6,30€ - Menù: 8,80€</br></br>",
            "6,30€ - Menù: 8,80€</br></br>",
            "6,30€ - Menù: 8,80€</br></br>",
            "6,30€ - Menù: 8,80€</br></br>",
            "6,30€ - Menù: 8,80€</br></br>",
        ],
    },
    {
        header: "INSALATE",
        content: [
            "<strong>LA NABBA</strong></br>Insalata gentile, mais, olive nere, grana padano D.O.P. in scaglie, pomodoro ramato</br>",
            "<strong>LA PRO</strong></br>Insalata gentile, pomodoro ramato, zucchine e peperoni alla piastra, fagioli rosi</br>",
            "<strong>HUB SALAD</strong></br>Prosciutto crudo Jamon Serrano, rucola, pomodoro ramato, maionese</br>",
            "<strong>SEASON 4</strong></br>Cavolo cappuccio saltato, rucola, zucchine alla piastra, pomodoro ramato</br>",
        ],
        prezzo: [
            "singola 7,50€ - Menù: 10€ - extra: hamburger in pezzi o pollo croccante +2,50€",
            "singola 8€ - Menù: 10,50€ - extra: hamburger in pezzi o pollo croccante +2,50€",
            "singola 9€ - Menù: 11,50€ - extra: hamburger in pezzi o pollo croccante +2,50€",
            "singola 11,50€ - Menù: 14€ - extra: hamburger in pezzi o pollo croccante +2,50€",
        ],
    },
];
